export const INTAKE_PAGE_ACTION_SOURCE = 'intake_page';
export const FINANCE_INTAKE_PAGE_ACTION_SOURCE = 'finance_intake_page';
export const EDIT_QUESTION_POPUP_ACTION_SOURCE = 'edit_question_popup';
export const FEED_PAGE_TREATMENT_WIDGET_ACTION_SOURCE = 'feed_page_treatment_widget';
